import { QueryClient } from '@tanstack/react-query';

import { QUERY_KEY as REVIEW_SCORECARDS_QUERY_KEY } from './useReviewScorecardsQuery';
import { QUERY_KEY as REVIEW_ACTION_ITEMS_QUERY_KEY } from './useReviewActionItemsQuery';
import { QUERY_KEY as REVIEW_MOMENTS_QUERY_KEY } from './useMomentsQuery';
import { QUERY_KEY as REVIEW_CLASS_SUMMARY_QUERY_KEY } from './useReviewClassSummaryQuery';
import { QUERY_KEY as REVIEW_DATA_LOG_QUERY_KEY } from './useReviewDataLogQuery';
import { QUERY_KEY as REVIEW_DAY_COUNTS_QUERY_KEY } from './useReviewDayCountsQuery';
import { QUERY_KEY as REVIEW_INSIGHTS_QUERY_KEY } from './useInsightsQuery';
import { QUERY_KEY as REVIEW_REMINDERS_QUERY_KEY } from './useRemindersListAllQuery';

/** Every review query whose content is derived from a period+day's review content, and so
 *  can go stale whenever that content meaningfully changes — a day-status transition, a
 *  session close, a review deletion, or the mock-mode day-status override.
 *
 *  Deliberately excludes `REVIEW_DAY_STATUS_QUERY_KEY`: that query is the *driver* of these
 *  changes, not a dependent of them. Callers that also caused (or are simulating) a day-status
 *  transition should invalidate that key separately, alongside this list. */
export const DEPENDENT_REVIEW_QUERY_KEYS = [
  REVIEW_SCORECARDS_QUERY_KEY,
  REVIEW_ACTION_ITEMS_QUERY_KEY,
  REVIEW_MOMENTS_QUERY_KEY,
  REVIEW_CLASS_SUMMARY_QUERY_KEY,
  REVIEW_DATA_LOG_QUERY_KEY,
  REVIEW_DAY_COUNTS_QUERY_KEY,
  REVIEW_INSIGHTS_QUERY_KEY,
  REVIEW_REMINDERS_QUERY_KEY,
];

/** Invalidates every review query in `DEPENDENT_REVIEW_QUERY_KEYS`. Single source of truth so
 *  the set can't silently drift out of sync across the several places that need it. */
export function invalidateDependentReviewQueries(queryClient: QueryClient) {
  DEPENDENT_REVIEW_QUERY_KEYS.forEach((key) => queryClient.invalidateQueries({ queryKey: [key] }));
}
